import axios from "axios";
import { cleanSlugUrl } from "../../helpers/cleanSlugUrl";
// chargement des données de Strapi
export const strapiLoader = url => async () => {
    const API_KEY = process.env.REACT_APP_STRAPI_API_KEY;
    const IDENTIFIER = process.env.REACT_APP_STRAPI_ADMIN_EMAIL;
    const PASSWORD = process.env.REACT_APP_STRAPI_ADMIN_PASSWORD;

    try {
        const response = await axios.get(
            url,
            {
                identifier: IDENTIFIER,
                password: PASSWORD,
            },
            {
                headers: {
                    Authorization: `Bearer ${API_KEY}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return {
            data: response.data,
            error: null,
            loading: false,
        };
    } catch (error) {
        return {
            data: null,
            error: error.message,
            loading: false,
        };
    }
};

export const strapiLoaderBlog = async slug => {
    const API_KEY = process.env.REACT_APP_STRAPI_API_KEY;
    const IDENTIFIER = process.env.REACT_APP_STRAPI_ADMIN_EMAIL;
    const PASSWORD = process.env.REACT_APP_STRAPI_ADMIN_PASSWORD;

    const apiUrl = `${process.env.REACT_APP_WEBSITE_URL_BACKEND}/api/blogs?populate=*`;

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${API_KEY}`,
                "Content-Type": "application/json",
            },
            auth: { username: IDENTIFIER, password: PASSWORD },
        });

        const blogs = response.data.data || [];
        const blog = blogs.find(b => cleanSlugUrl(b.Title) === slug);

        if (!blog) {
            return { data: null, error: "Blog not found", loading: false };
        }

        return { data: blog, error: null, loading: false };
    } catch (error) {
        return { data: null, error: error.message, loading: false };
    }
};
